var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{attrs:{"variant":"danger"}},[_c('ul',{staticClass:"mb-1 errorClass"},_vm._l((_vm.errors),function(error,index){return _c('li',{key:index},[_vm._v(" "+_vm._s(error)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }